import * as angular from "angular";
import {IController} from "angular";
import {Rule} from "../../models/rule.model";
import {RuleControllerStage} from "../../models/rule-controller-stage.model";
import {RuleActionModel} from "../../models/rule-action.model";

export class RulesTableRowComponent implements IController {

  rule: Rule;
  onEditRule: Function;
  onDeleteRule: Function;

  public actionsList: string[];

  constructor() {
  }

  $onInit() {
    if (this.rule) {
      this._initRuleActions();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.rule && !changes.rule.isFirstChange()) {
      this._initRuleActions();
    }
  }

  private _initRuleActions() {
    this.actionsList = [];
    this.rule.stages[1].operations.forEach((o: RuleControllerStage) => {
      o.actions.forEach((a: RuleActionModel) => {
        this.actionsList.push(a.actionType);
      })
    })
  }

}

angular
  .module('bringoz.admin.ruleEngine')
  .component('rulesTableRow', {
    bindings: {
      rule: '<',
      onEditRule: '&',
      onDeleteRule: '&'
    },
    template: require('./rules-table-row.html').default,
    controller: RulesTableRowComponent
  });
